// The inspector's card grows out of the card tapped, and shrinks back into it
// on closing, so it is plainly the same card. The card tapped may be a tile,
// cropped below the band: the zoom starts cropped the same way and opens to
// the whole card. Copied from hutchies/imperium src/imperium/ui/phone/zoom.js.
import { get } from 'svelte/store';
import { inspected, cardOf } from './phone.js';
import { faceImage, thumbURL } from './face.js';

const MS = 260;
const EASE = 'cubic-bezier(.2,.7,.25,1)';
const still = () => typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;

// From the card's rect `r` to the element's rect `a`, scaled by width; the
// part of the element below the card's own height is clipped off at the start.
function frames(r, a){
    const s = r.width / a.width;
    const cut = Math.max(0, a.height - r.height / s);
    return [
        { transform: `translate(${r.left - a.left}px, ${r.top - a.top}px) scale(${s})`, clipPath: `inset(0 0 ${cut}px 0 round 5px)` },
        { transform: 'none', clipPath: 'inset(0 0 0 0 round 7px)' }
    ];
}

// The inspector's card element has just been drawn for a card tapped at `from`.
export function zoomIn(el, from){
    if(!el || !from || still()) return;
    const a = el.getBoundingClientRect();
    if(!a.width) return;
    el.style.transformOrigin = '0 0';
    el.animate(frames(from, a), { duration: MS, easing: EASE });
}

// Close the inspector; its card shrinks back into the card it came from, if
// that is still on screen.
export function closeInspector(){
    const now = get(inspected);
    const art = document.querySelector('[data-testid=phone-inspector]');
    inspected.set(null);
    if(!now || !art || still()) return;
    const card = [...document.querySelectorAll(`.stcc-phone .pc[data-card="${CSS.escape(String(now.id))}"]`)]
        .find(el => !el.closest('[data-testid=phone-inspector]'));
    const r = card?.getBoundingClientRect();
    if(!r?.width || r.bottom < 0 || r.top > innerHeight) return;
    const img = faceImage(cardOf(now.id));
    if(!img) return;
    const a = art.getBoundingClientRect();
    const copy = document.createElement('img');
    copy.src = thumbURL(img);
    Object.assign(copy.style, { position: 'fixed', left: `${a.left}px`, top: `${a.top}px`, width: `${a.width}px`, height: `${a.height}px`,
        objectFit: 'cover', objectPosition: 'top', zIndex: 650, pointerEvents: 'none', transformOrigin: '0 0', borderRadius: '7px' });
    document.body.appendChild(copy);
    const anim = copy.animate([...frames(r, a)].reverse(), { duration: 220, easing: EASE, fill: 'forwards' });
    anim.onfinish = anim.oncancel = () => copy.remove();
}
